import axios from "axios";
import { baseUrl } from '../config';
// import store from '../store';
// import handlerError from '@/utils/handlerError';
// axios service 


export default function createInstance() {
    let instance = axios.create({
      //  baseURL: "http://localhost:9001/api",
      // baseURL: "http://192.168.1.182:9001/api",
      // baseURL: 'http://192.168.1.133:9001/api',
      //baseURL: "http://192.168.43.242:9000",
      // baseURL: process.env.VUE_APP_URL,
      baseURL: baseUrl,
      timeout: 0,
      headers: {
        accept: "application/json",
        "content-type": "application/json"
      },
    });
    
    instance.interceptors.response.use((response) => {
      // console.log('resp onse', response)
      return Promise.resolve(response);
    },(error) => {
      console.log('axios error', error.response.data);
      // handlerError(error.response.data);
      return Promise.reject(error);
      // return error;
    })
    return instance;

}
